

export const solutions = {
  preorders: {
    id: "preorders",
    name: "Pre orders campaign",
    description:
      "Start pre-orders of your game or content. You can distribute it via Game Keys (Steam, GOG, EGS etc.), Xsolla Louncher or a file.",
    products: [
      {
        product: "game_store",
        name: "Create a pre-order button",
        link: "/game_store/newkey",
        required: true,
        available: true,
      },
      {
        product: "game_store",
        name: "Sign licensing agreement",
        link: '/',
        action: 'licensing',
        required: true,
        available: true,
      },
      {
        product: ["login", "mailchimp"],
        name: "Add a Mailchimp™ export",
        link: '/',
        action: 'mailchimp',
        required: true,
        available: true,
      },
      {
        product: "game_store",
        name: "Get a widget code",
        link: "/game_store/newwidget",
        required: false,
        available: true,
      },
      {
        product: ["site_builder", "login"],
        name: "Create a landing page",
        link: "/game_store/newsite",
        required: false,
        available: true,
      },
      {
        product: ["partner_network"],
        name: "Connect Partner Network",
        link: "/partner_network/newsite",
        required: false,
        available: true,
      }
    ]
  },
  ingame: {
    id: "ingame",
    name: "In-game Microtransactions",
    description: "Monetize your free2play game",
    products: [
      {
        product: "ingame",
        name: "Set up in-game items catalog",
        link: "/microtransactions/virtual_items/",
        required: false,
        available: true,
      },
      {
        product: "ingame",
        name: "Set up virtual currency",
        link: "/microtransactions/virtual_currency/",
        required: false,
        available: true,
      },
      {
        product: "ingame",
        name: "Set up subscriptions",
        link: "/subscriptions/plans",
        required: false,
        available: true,
      },
      {
        product: "global",
        name: "Set up webhooks",
        link: "/webhooks/",
        required: false,
        available: true,
      },
      {
        product: ["site_builder", "login"],
        name: "Create an Embed Page / E-shop",
        link: "/site_builder/?template=4",
        required: false,
        available: true,
      }
    ]
  },
  community: {
    id: "community",
    name: "Community Gathering",
    description: "Own your community!",
    products: [
      {
        product: ["site_builder", "login", "forum"],
        name: "Create Landing Page with User Subscription",
        link: "/site_builder/?template=2",
        required: false,
        available: true,
      },
      {
        product: ["partner_network"],
        name: "Use streamers to drive audience to your page.",
        link: "/partner_network",
        required: false,
        available: true,
      },
    ]
  }
}


